"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 12.585l3.015 3.015.585-.585L12.585 12 15.6 8.985l-.585-.585L12 11.415 8.985 8.4l-.585.585L11.415 12 8.4 15.015l.585.585L12 12.585z" }), "Decline");
//# sourceMappingURL=Decline.js.map